module.exports = __webpack_public_path__ + "static/media/cv-library-preview.5b981d5c.png";